import AddReportNode from './People/AddReportNode';
import MembershipNode from './People/MembershipNode';
import WorkspaceNode from './WorkspaceNode';
import PlanNode from './Plan/PlanNode';
import PlanMap from './Plan/PlanMap';
import PeopleMap from './People/PeopleMap';

interface MapNode {
  id: string;
  name?: string;
  type?: string;
  children: string[];
  width?: number;
  height?: number;
  parents: string[];
  hidden?: boolean;
  meta?: any;
}

const entitreeSettings = {
  clone: true, // returns a copy of the input, if your application does not allow editing the original object
  enableFlex: true, // has slightly better performance if turned off (node.width, node.height will not be read)
  firstDegreeSpacing: 50, // spacing in px between nodes belonging to the same source, e.g. children with same parent
  nextAfterAccessor: 'spouses', // the side node prop used to go sideways, AFTER the current node
  nextAfterSpacing: 50, // the spacing of the "side" nodes AFTER the current node
  nextBeforeAccessor: 'siblings', // the side node prop used to go sideways, BEFORE the current node
  nextBeforeSpacing: 50, // the spacing of the "side" nodes BEFORE the current node
  rootX: 0, // set root position if other than 0
  rootY: 0, // set root position if other than 0
  secondDegreeSpacing: 50, // spacing in px between nodes not belonging to same parent eg "cousin" nodes
  sourcesAccessor: 'parent', // the prop used as the array of ancestors ids
  sourceTargetSpacing: 50, // the "vertical" spacing between nodes in vertical orientation, horizontal otherwise
  targetsAccessor: 'children', // the prop used as the array of children ids
};

const DEFAULT_WORKSPACE_HEIGHT = 80;

export {
  AddReportNode,
  MembershipNode,
  WorkspaceNode,
  PlanNode,
  entitreeSettings,
  DEFAULT_WORKSPACE_HEIGHT,
  PeopleMap,
  PlanMap,
};

export type { MapNode };
